// Face API loader — loads face-api.js models from a public CDN and provides helpers.
// Uses TinyFaceDetector + FaceLandmark68Net + FaceRecognitionNet for 128-float descriptor.
import * as faceapi from "face-api.js";

const MODEL_URL = "https://justadudewhohacks.github.io/face-api.js/models";
let loaded = false;
let loading = null;

export const loadFaceModels = () => {
  if (loaded) return Promise.resolve();
  if (loading) return loading;
  loading = (async () => {
    await Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
      faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
      faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
    ]);
    loaded = true;
  })();
  return loading;
};

// Given an HTMLVideoElement or HTMLImageElement, detect the largest face and return
// a 128-float descriptor. Returns null if no face is detected.
export const computeDescriptor = async (input) => {
  const detection = await faceapi
    .detectSingleFace(input, new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.5 }))
    .withFaceLandmarks()
    .withFaceDescriptor();
  if (!detection) return null;
  return Array.from(detection.descriptor);
};

// Euclidean distance between two descriptors (0 = identical, > 0.6 = different person)
export const distance = (a, b) => {
  if (!a || !b || a.length !== b.length) return Infinity;
  let s = 0;
  for (let i = 0; i < a.length; i++) s += (a[i] - b[i]) ** 2;
  return Math.sqrt(s);
};

export { faceapi };
